import PropTypes from 'prop-types';

const SummaryCard = ({ label, value, sub, icon: Icon, color }) => (
  <div className="bg-white rounded-lg border border-gray-200 p-4 flex items-start gap-3">
    <div className={`rounded-lg p-2 ${color}`}>
      <Icon className="w-5 h-5" />
    </div>
    <div>
      <p className="text-xs text-gray-500">{label}</p>
      <p className="text-base font-semibold text-gray-800">{value}</p>
      {sub && <p className="text-xs text-gray-400 mt-0.5">{sub}</p>}
    </div>
  </div>
);

SummaryCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node,
  sub: PropTypes.node,
  icon: PropTypes.elementType.isRequired,
  color: PropTypes.string,
};

export default SummaryCard;
